import LoadingSpinner from "./LoadingSpinner";

const LoadingTableSpinner = ({columns, variant, ...props}) => {
    return (
        <tr>
            <td colSpan={columns}>
                <LoadingSpinner variant={variant} {...props}/>
            </td>   
        </tr>
    );
};

export default LoadingTableSpinner;